import {Sprite} from 'pixi.js';
import {StickyRichLabelData, StickyRichTextLabelComponent} from '@gongxigames/framework/slot/modules/watermark';
import {ObjectBuilder, ScreenParameters} from '@gongxigames/framework/core';

export class WaterMarkLabels {

    protected labelsList: StickyRichTextLabelComponent[] = [];

    constructor(
        protected imageSprite: Sprite,
        protected objectBuilder: ObjectBuilder
    ) {}

    public addRichLabel(data: StickyRichLabelData): StickyRichTextLabelComponent {
        const result = this.createRichLabel(data);

        this.labelsList.push(result);

        return result;
    }

    public resize(screenParams: ScreenParameters, isFullscreen: boolean): void {
        this.labelsList.forEach( label => {
            label.resize(screenParams, isFullscreen);
        });
    }

    public restoreStartPosition(): void {
        this.labelsList.forEach( label => {
            label.restoreStartPosition();
        });
    }

    public restoreInitialStickyPosition(): void {
        this.labelsList.forEach( label => {
            label.restoreInitialStickyPosition();
        });
    }

    protected createRichLabel(data: StickyRichLabelData): StickyRichTextLabelComponent {
        const result = new StickyRichTextLabelComponent(data, this.objectBuilder, this.imageSprite);

        return result;
    }
}
